import { Col, Row } from 'antd';
import { Auth } from 'aws-amplify';
import React, { useState, useEffect, ReactElement, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { AccountUser } from '../../../../api/accounts/users';
import { User } from '../../../../interfaces/api/Auth';
import { api } from '../../../../utils/axiosConfig';
import Loading from '../../../loading';
import TeamManagement from './TeamManagement';

const TeamManagementContainer = (): ReactElement => {
  const { accountId } =
    useParams<{
      accountId: string;
    }>();
  const [user, setUser] = useState<User>();
  const [users, setUsers] = useState<AccountUser[]>();

  const fetchUsers = useCallback(() => {
    api('GET', `${accountId}/members`).then((res) =>
      setUsers(res.data as AccountUser[])
    );
  }, [accountId]);

  useEffect(() => {
    Auth.currentUserPoolUser().then((user: User) => {
      setUser(user);
    });

    fetchUsers();
  }, [fetchUsers]);

  const invite = async (email: string) => {
    return api('POST', `${accountId}/members`, {
      email
    }).then(() => {
      fetchUsers();
    });
  };

  const remove = async (userId: string) => {
    return api('DELETE', `${accountId}/members/${userId}`).then(() => {
      fetchUsers();
    });
  };

  if (!user || !users)
    return (
      <Row justify="center">
        <Col>
          <Loading />
        </Col>
      </Row>
    );

  return (
    <TeamManagement user={user} users={users} invite={invite} remove={remove} />
  );
};
export default TeamManagementContainer;
